import { useCallback } from 'react';

var useGetPinchZoomUtils = function useGetPinchZoomUtils() {
  var disableZoomFunction = useCallback(function () {
    document.body.style.zoom = 0.99;
  }, []);
  var disablePinchZoom = useCallback(function () {
    if (document.querySelector('meta[name="viewport"]')) {
      document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }
    document.addEventListener('gesturestart', disableZoomFunction);
    document.addEventListener('gesturechange', disableZoomFunction);
    document.addEventListener('gestureend', disableZoomFunction);
  }, []);
  var enablePinchZoom = useCallback(function () {
    if (document.querySelector('meta[name="viewport"]')) {
      document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=device-width,initial-scale=1,viewport-fit=cover');
    }
    document.removeEventListener('gesturestart', disableZoomFunction);
    document.removeEventListener('gesturechange', disableZoomFunction);
    document.removeEventListener('gestureend', disableZoomFunction);
  }, []);
  return {
    enablePinchZoom: enablePinchZoom,
    disablePinchZoom: disablePinchZoom
  };
};

export { useGetPinchZoomUtils };
